import { render, staticRenderFns } from "./StarRatings.vue?vue&type=template&id=06090006&"
import script from "./StarRatings.vue?vue&type=script&lang=js&"
export * from "./StarRatings.vue?vue&type=script&lang=js&"
import style0 from "./StarRatings.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports